import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

/**
 * A 403 that did not come from the app: Cloud Armor answers a WAF match with its own HTML
 * page, so there is no `message` to show and the toast every 403 gets rendered empty.
 * `handleErrors` gives such a refusal this code and a translatable key instead.
 */
export const REQUEST_BLOCKED_CODE = 'REQUEST_BLOCKED' as const;
export const REQUEST_BLOCKED_MESSAGE = 'VALIDATION__RequestBlocked' as const;

export type ForbiddenErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class ForbiddenError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  // `code` forwarded, like `BadRequestError` and `ConflictError` already do.
  // `ORG_BILLING_LOCKED` is a 403, and it is the code — not the sentence — that
  // the payments flow branches on to reach its translated copy.
  constructor({ code, message }: ForbiddenErrorArgs<TErrors>) {
    super({ code, errors: null, message, status: HttpStatus.Forbidden });
  }
}
